import { useParams } from 'react-router-dom';

import { Approved } from './Approved';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';
import { BackToDashboard } from '../../../BackToDashboard';

export const ApprovedPage = () => {
    const { accountId } = useParams<{ accountId: string }>();

    if (!accountId) {
        return <FallbackErrorModal />;
    }

    return (
        // 72px is the height of the navbar
        <div className="min-h-[calc(100vh-72px)] bg-secondary-95 px-m pb-2xl">
            <div className="mx-auto max-w-[960px] pt-l">
                <BackToDashboard />
                <Approved accountId={accountId} />
            </div>
        </div>
    );
};
